// DEPLOY: /var/www/woody.wtf/frontend/src/pages/EtfWorkspace.js
// Use the actual Workspace page, substituting ETF holdings for MarketScanner.
import React from 'react';
import Workspace from './Workspace';

export default function EtfWorkspace() {
  const query = new URLSearchParams(window.location.search);
  const key = (query.get('symbol') || '') + ':' + (query.get('exchange') || 'AU');
  return <Workspace key={key} etf />;
}
